import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from './AuthGate';
import { Shell } from './Shell';
import { theme } from './theme';
import { Placeholder } from './Placeholder';
import { JobBoard } from './pages/JobBoard';
import { Settlements } from './pages/Settlements';
import { PrintLabPage } from './pages/PrintLabPage';

// Declared once at module scope so the array identity is stable across
// renders and the Firestore subscription is not torn down on every paint.
const NEW_JOBS = ['ASSIGNED'] as const;
const IN_PRODUCTION = ['ACCEPTED', 'IN_PRODUCTION'] as const;
const READY = ['READY'] as const;
const DISPATCHED = ['DISPATCHED'] as const;

/**
 * Vendor portal. Everything here reads the redacted `vendorJobs` projection —
 * never `orders` — so a vendor can see the job without seeing what the
 * customer paid. Screens land in Phase 6.
 */
export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthGate requiredRole="vendor">
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Navigate to="/jobs" replace />} />
              <Route
                path="/jobs"
                element={
                  <JobBoard
                    title="New jobs"
                    statuses={[...NEW_JOBS]}
                    emptyMessage="No new jobs waiting. We will email you when one arrives."
                  />
                }
              />
              <Route
                path="/production"
                element={
                  <JobBoard
                    title="In production"
                    statuses={[...IN_PRODUCTION]}
                    emptyMessage="Nothing on the press right now."
                  />
                }
              />
              <Route
                path="/dispatch"
                element={
                  <JobBoard
                    title="Ready to dispatch"
                    statuses={[...READY]}
                    emptyMessage="Nothing waiting to go out."
                  />
                }
              />
              <Route
                path="/dispatched"
                element={
                  <JobBoard
                    title="Dispatched"
                    statuses={[...DISPATCHED]}
                    emptyMessage="Nothing dispatched yet."
                  />
                }
              />
              <Route path="/settlements" element={<Settlements />} />
              <Route path="/print-lab" element={<PrintLabPage />} />
              <Route path="*" element={<Placeholder title="Not found" phase="" />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </AuthGate>
    </ThemeProvider>
  );
}
